// actions
export const REMOVE = 'remove';
export const CLONE = 'clone';
